import {AddFileNoteRequest, FullFile, SelectOption} from "../api/ApiTypes.ts";
import {SamSelect} from "./SamSelect.tsx";
import SamButton from "./SamButton.tsx";
import React, {useState} from "react";
import {useOrderApi} from "../context/ApiContext.tsx";
import CancelButton from "./CancelButton.tsx";


interface AddFileNoteProps {
    orderId: number,
    files: FullFile[],
    onSuccess: () => void,
    onCancel: () => void
}

export const AddFileNoteForm: React.FC<AddFileNoteProps> = ({
    orderId,
    files,
    onSuccess,
    onCancel
}) => {

    const defaultState: AddFileNoteRequest = {
        orderId: orderId,
        fileName: '',
        message: ''
    };

    const orderApi = useOrderApi();
    const [ formData, setFormData ] = useState<AddFileNoteRequest>(defaultState);
    const dropDownFiles = files.map((file): SelectOption => ({
        id: file.id,
        label: file.fileName,
        value: file.fileName
    }));

    const handleSubmit = () => {

        orderApi.addFileNote(formData).then(_ => {
            onSuccess();
        }).catch(console.log);
    }

    const handleCancel = () => {

        setFormData(defaultState);
        onCancel();
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="col-span-1">
                <label htmlFor="file" className="block text-sm font-medium text-gray-700 mb-1">
                    File
                </label>
                <SamSelect
                    value={formData.fileName}
                    onChange={(e) => {
                        setFormData(prev => ({
                            ...prev,
                            fileName: e
                        }))
                    }}
                    options={dropDownFiles}
                    placeholder="Select file"
                />
            </div>

            <textarea
                id="fileMessage"
                rows={5}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Note"
                value={formData.message}
                onChange={(e) => {
                    setFormData(prev => ({
                        ...prev,
                        message: e.target.value
                    }));
                }}
            />

            <div className="flex justify-end space-x-2">
                <CancelButton
                    type="button"
                    onClick={handleCancel}
                >
                    Cancel
                </CancelButton>
                <SamButton
                    type="submit"
                >
                    Add Note
                </SamButton>
            </div>
        </form>
    )
}